var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 50,
    viewBox: "0 0 68 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M13.7007 19.2524L2.70068 31.856V49.9998H67.5V1.78906L59.7007 13.7891L53.1002 12.9449L46.7007 26.7524L37.7007 19.7524L25.7007 29.2524L13.7007 19.2524Z",
    fill: "url(#paint0_linear_3861_4171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21924 31.3747L11.0464 21.7988C12.545 19.9654 15.2996 19.828 16.9732 21.5033L22.8244 27.3602C24.3868 28.9241 26.9216 28.9241 28.484 27.3602L34.3005 21.538C35.9865 19.8504 38.7656 20.0043 40.2549 21.8678L42.3138 24.4439C44.2938 26.9213 48.2316 26.2193 49.2336 23.2104L51.7319 15.708C52.354 13.8399 54.2431 12.7023 56.1853 13.0263L57.2091 13.1971C58.8308 13.4677 60.4528 12.7184 61.2981 11.3082L66.9818 1.82617",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18829 32.682L2.96087 32.9887C2.40131 33.0419 1.90785 32.6236 1.86868 32.0629L1.64004 28.7898",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3861_4171",
    x1: 35.1004,
    y1: 16.8225,
    x2: 35.1004,
    y2: 49.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4444",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownGraph);
export default __webpack_public_path__ + "static/media/downGraph.5332dd845e9a47e2f61e017c62d432a2.svg";
export { ForwardRef as ReactComponent };